import React from "react";
import Header from '../component/Header.jsx';
// import FeatureWhyChoose from './FeaturePageSection/FeatureWhyChoose';
// import FeatureAboutUs from "./FeaturePageSection/FeatureAboutUs";
import FeatureProcess from "./FeaturePageSection/FeatureProcess";
import FeatureLevelUp from "./FeaturePageSection/FeatureLevelUp";
// import FeatureInnovation from "./FeaturePageSection/FeatureInnovation.jsx";
// import Footer from '../component/Footer';
 
// import  "../style/pages/FeaturePage/FeatureWhyChoose.css";

// import "../style/pages/FeaturePage/FeatureAboutUs.css";
import "../style/pages/FeaturePage/FeatureProcess.css";
import "../style/pages/FeaturePage/FeatureLevelUp.css";
// import "../style/pages/FeaturePage/FeatureInnovation.css";

function FeaturePageSection({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  return (
  <>
  {/* <Header
    isLoggedIn={isLoggedIn}
    setLoginModalOpen={setLoginModalOpen}
    handleLogout={handleLogout}
  />
  <FeatureWhyChoose />
  <FeatureAboutUs />
  <FeatureProcess 
    isLoggedIn={isLoggedIn}
    setLoginModalOpen={setLoginModalOpen}
    handleLogout={handleLogout}
  />
  <FeatureLevelUp />
  <FeatureInnovation /> */}
  {/* <Footer /> */}
  </>
    
    
  );
  
}

export default FeaturePageSection;
